import React from 'react';
import Footer from '../components/Footer';
import { Image } from 'react-bootstrap';

const Page404: React.FC = () => {
    return (
        <>
            <section className="registration-nav">
                </section>
                <section className="section-login p-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-5 offset-lg-1 pt-lg-5 pt-3">
                                <div className="login-wrapper pt-lg-5 pt-3 text-center">
                                    404 ページが存在しません
                                </div>
                            </div>
                            <div className="col-lg-6 text-center">
                                <div>
                                    <Image src="assets/images/login/full-demo-logo.png" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="section-login-contents text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-10 mx-auto mt-lg-4 mt-2">
                                <h3 className="text-md">Ene Bidとは</h3>
                                <div className="section-title-border-bottom mb-sm-4 mb-3"></div>
                                <p className="mb-lg-5 mb-sm-4 mb-3 text-sm text-left">電力供給契約を変更検討中のお客様情報をデータベース化し、
                                    電力会社の方へ連携することで自由競争を促す自動応札システムです。</p>
                                <h3 className="text-md">３つのメリット</h3>
                                <div className="section-title-border-bottom mb-lg-5 mb-sm-4 mb-3"></div>
                                <div className="row">
                                    <div className="col-md-4 text-center row-eq-height">
                                        <div className="login-item">
                                            <Image src="assets/images/login/user-chart.svg" />
                                            <p><strong>契約を見直したい<br />新規顧客を探せる</strong></p>
                                        </div>
                                    </div>
                                    <div className="col-md-4 text-center row-eq-height">
                                        <div className="login-item">
                                            <Image src="assets/images/login/user-building.svg" />
                                            <p><strong>他社に切り替え検討中の<br />契約者がわかる</strong></p>
                                        </div>
                                    </div>
                                    <div className="col-md-4 text-center row-eq-height">
                                        <div className="login-item">
                                            <Image src="assets/images/login/office.svg" />
                                            <p><strong>応札条件を<br />柔軟に決められる</strong></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            <Footer />
        </>
    )
}

export default Page404;